import React from 'react';
import { Button } from 'react-bootstrap';
import "./ButtonSecondary.css";

const ButtonSecondary = ({children, action, className}) =>{
    return(        
        <Button bsPrefix='ButtonSecondary' onClick={()=>{action()}} className={className}>{children}</Button>
    );
};

export default ButtonSecondary;